import createDiningCard from './createDiningCard';
import createEventCard from './createEventCard';
import createFlightCard from './createFlightCard';
import createLodgingCard from './createLodgingCard';
import createInvoiceCard from './createInvoiceCard';
import createParcelDeliveryCard from './createParcelDeliveryCard';
import createRentalCarCard from './createRentalCarCard';
import createReservationCard from './createReservationCard';
import createServiceReservationCard from './createServiceReservationCard';
import getCalendarEventId from './getCalendarEventId';
import Activity from '../../schema/Activity';
import ActivityType from '../../schema/innerSchema/ActivityType';
import CardItem from '../../schema/viewSchema/CardItem';
import CardRole from '../../schema/innerSchema/CardRole';
import Entity from '../../schema/Entity';
import EventReservation from '../../schema/EventReservation';
import FlightReservation from '../../schema/FlightReservation';
import FoodEstablishmentReservation from '../../schema/FoodEstablishmentReservation';
import Invoice from '../../schema/Invoice';
import LodgingReservation from '../../schema/LodgingReservation';
import ParcelDelivery from '../../schema/ParcelDelivery';
import RentalCarReservation from '../../schema/RentalCarReservation';
import Reservation from '../../schema/Reservation';
import ServiceReservation from '../../schema/ServiceReservation';
import TxpImages from '../../schema/configSchema/TxpImages';
import TxpStrings from '../../schema/configSchema/TxpStrings';

export default function createCardItem(
    activityItem: Activity,
    currentEntity: Entity,
    isBusStop: boolean,
    showEnhancedLocation: boolean,
    txpStrings: TxpStrings,
    txpImages?: TxpImages,
    cardRole?: CardRole,
    calendarEventIds?: any[]
): CardItem {
    let currentCard: CardItem;
    let calendarEventId: string;
    let activityId: string = activityItem.activityId;
    if (calendarEventIds) {
        calendarEventId = getCalendarEventId(activityItem, calendarEventIds);
    }

    txpImages = txpImages ? txpImages : {};
    let detailsIcons = txpImages.detailsIcons ? txpImages.detailsIcons : {};
    let getImage = entityIllustration => (entityIllustration ? entityIllustration.image : null);
    let getIcon = entityIllustration => (entityIllustration ? entityIllustration.icon : null);
    let setReservationStatusOnCard: boolean = true;

    switch (activityItem.type) {
        case ActivityType.FlightDeparture: {
            let flightEntity = currentEntity as FlightReservation;
            currentCard = createFlightCard(
                flightEntity,
                isBusStop,
                activityId,
                getImage(txpImages.flight),
                txpStrings,
                getIcon(txpImages.flight),
                calendarEventId,
                detailsIcons
            );
            break;
        }
        case ActivityType.ParcelDelivery: {
            let parcelDeliveryEntity = currentEntity as ParcelDelivery;
            currentCard = createParcelDeliveryCard(
                parcelDeliveryEntity,
                activityId,
                !showEnhancedLocation,
                getImage(txpImages.parcelDelivery),
                txpStrings,
                getIcon(txpImages.parcelDelivery),
                calendarEventId,
                detailsIcons
            );

            break;
        }
        case ActivityType.RentalCarPickup:
        case ActivityType.RentalCarDropOff: {
            let rentalCarEntity = currentEntity as RentalCarReservation;
            currentCard = createRentalCarCard(
                rentalCarEntity,
                isBusStop,
                activityItem.type,
                activityId,
                !showEnhancedLocation,
                getImage(txpImages.rentalCar),
                txpStrings,
                getIcon(txpImages.rentalCar),
                cardRole,
                calendarEventId,
                detailsIcons
            );
            break;
        }
        case ActivityType.HotelCheckin:
        case ActivityType.HotelCheckout: {
            let lodgingEntity = currentEntity as LodgingReservation;
            currentCard = createLodgingCard(
                lodgingEntity,
                isBusStop,
                activityItem.type,
                activityId,
                !showEnhancedLocation,
                getImage(txpImages.lodging),
                txpStrings,
                getIcon(txpImages.lodging),
                cardRole,
                calendarEventId,
                detailsIcons
            );
            break;
        }
        case ActivityType.EventActivityType: {
            let eventEntity = currentEntity as EventReservation;
            currentCard = createEventCard(
                eventEntity,
                isBusStop,
                activityId,
                !showEnhancedLocation,
                getImage(txpImages.event),
                txpStrings,
                getIcon(txpImages.event),
                calendarEventId,
                detailsIcons
            );
            break;
        }
        case ActivityType.Dining: {
            let diningEntity = currentEntity as FoodEstablishmentReservation;
            currentCard = createDiningCard(
                diningEntity,
                isBusStop,
                activityId,
                !showEnhancedLocation,
                getImage(txpImages.dining),
                txpStrings,
                getIcon(txpImages.dining),
                calendarEventId,
                detailsIcons
            );
            break;
        }
        case ActivityType.InvoiceDue:
        case ActivityType.InvoiceScheduled: {
            let invoiceEntity = currentEntity as Invoice;
            currentCard = createInvoiceCard(
                invoiceEntity,
                isBusStop,
                activityItem.type,
                activityId,
                getImage(txpImages.invoice),
                txpStrings,
                getIcon(txpImages.invoice),
                calendarEventId,
                detailsIcons
            );

            break;
        }
        case ActivityType.ServiceAppointment: {
            let serviceReservationEntity = currentEntity as ServiceReservation;
            currentCard = createServiceReservationCard(
                serviceReservationEntity,
                isBusStop,
                activityId,
                !showEnhancedLocation,
                getImage(txpImages.serviceReservation),
                txpStrings,
                getIcon(txpImages.serviceReservation),
                calendarEventId,
                detailsIcons
            );

            setReservationStatusOnCard = false;
            break;
        }

        default: {
            currentCard = null;
        }
    }

    // Logic to check if reservation status has been set.
    // Reservation status will be set for Events, Dining, Lodging, Car Rentals and Flights.
    let reservationStatus: string =
        currentEntity && (currentEntity as Reservation).reservationStatus;
    if (currentCard && reservationStatus && setReservationStatusOnCard) {
        currentCard = {
            ...currentCard,
            ...createReservationCard(currentEntity as Reservation, txpStrings, detailsIcons),
        } as CardItem;
    }

    return currentCard;
}
